import React, {useState} from 'react';
import { Modal } from 'antd';

interface ReverseButtonProps {
    api: any;
    node: any;
    onEmailButton: (rowIndex: number) => void;
}

const SendMailButtonComponent: React.FC<ReverseButtonProps> = ({ api, node, onEmailButton }) => {

    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        onEmailButton(node.rowIndex)
        setIsModalOpen(false);

    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onButtonClick = () => {
        showModal()
    };

    return (
        <>
            <button
            onClick={onButtonClick}
            className=''
            style={{
                width: '20px',
                height: '20px',
                border: 'none',
                padding: 0,
                background: 'transparent',
                borderRadius: 0,
            }}
            >
                <img src="/images/email_icon.png" alt="Delete" style={{ width: '15px', height: '15px' }} />
            </button>
            <Modal 
                title="Email" 
                open={isModalOpen}
                onOk={handleOk} 
                onCancel={handleCancel}
                okText="Ok"
                width={300}
                okButtonProps={{ size: "small", style: { width: 80, fontSize: 12, backgroundColor: 'green', color: 'white'} }}
                cancelButtonProps={{ style: { display: 'none' } }}
            >
                <p>Are you sure you want to resend this report?</p>
            </Modal>
        </>    
    );
};

export default SendMailButtonComponent;